<template>
<div class="container">
    <div class="row d-flex justify-content-end">
        <div class="col-8">
            <h3 class="c-ndarkthree bold mb-0">
                <CheckingAccountIcon :color="getPrimaryColorHex.four" class="mr-0 mb-2" /> Contas correntes
            </h3>
            <p class="c-ndarkfour mt-0">
                Visualize suas contas correntes e selecione em qual delas deseja receber os pagamentos.
            </p>
        </div>
        <div class="col-4 d-flex align-items-end justify-content-end">
            <Button @click="newAccount" :color="getPrimaryColor">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.99983 1V9M1 5H8.99967" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                Nova conta
            </Button>
        </div>
    </div>
    <div class="row mt-4 pt-3">
        <div class="col-12">
            <TableLoading v-if="isLoading" rowHeight="56" :tableHeader="false" :rows="5"/>
            <BankAccount v-else-if="accountData.length" :account="accountId" :tableData="accountData" @change="handleChangeAccount($event)" />
            <div v-else class="mt-4 pt-5">
                <EmptyAccount />
            </div>
        </div>
    </div>
    <FullLoading :color="getPrimaryColorHex.five" />
</div>
</template>

<script>
import CheckingAccountIcon from '@/components/icons/CheckingAccount'
import BankAccount from '@/components/tables/BankAccount'
import EmptyAccount from '@/components/emptyOrNotFound/EmptyAccount'
import getBankAccount from '@/api/getBankAccount'
import FullLoading from '@/components/loading/FullLoading.vue'
import setMainBankAccount from '@/api/setMainBankAccount'
import TableLoading from '@/components/loading/TableLoading'

export default {
    components: {
        BankAccount,
        CheckingAccountIcon,
        EmptyAccount,
        FullLoading,
        TableLoading
    },
    data() {
        return {
            accountId: '4',
            accountData: [],
            dialogVisibleUserDelete: false,
            userToDelete: {
                id: null
            },
            loading: false,
            isLoading: false
        }
    },
    methods: {
        userDeleteRequest() {
            if (this.userToDelete.id != null) {
                console.log(`User com id ${this.userToDelete.id} deletado`)
            }
            this.userToDelete.id = null
        },
        newAccount() {
            this.$router.push('/bank/new')
        },
        async handleChangeAccount(accountId) {
            await setMainBankAccount(accountId)
            const resultGet = await getBankAccount(this.$store.state.user.cnpjId)
            this.accountData = resultGet.payload 
        }
    },
    async created() {
        this.isLoading = true

        const result = await getBankAccount(this.$store.state.user.cnpjId)
        this.accountData = result.payload
        const mainAccount = this.accountData.find((bankAccount) => bankAccount.mainAccount)
        this.$store.commit('user/setMainBank', mainAccount ? true : false)

        this.isLoading = false
    }

}
</script>

<style lang="scss" scoped>

</style>
